"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FormDefinitionConverter_1 = require("./FormDefinitionConverter");

var FormFieldConverter_1 = require("./FormFieldConverter");

var FormDefinition_1 = require("../FormDefinition");

var typescript_ioc_1 = require("@logio/typescript-ioc");
/**
 * Default implementation of FormDefinitionConverter.
 *
 * @author Radek Beran
 */


var FormDefinitionConverterImpl =
/*#__PURE__*/
function (_FormDefinitionConver) {
  _inherits(FormDefinitionConverterImpl, _FormDefinitionConver);

  function FormDefinitionConverterImpl(formFieldConverter) {
    var _this;

    _classCallCheck(this, FormDefinitionConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormDefinitionConverterImpl).call(this));
    _this._formFieldConverter = formFieldConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FormDefinitionConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new FormDefinition_1.FormDefinition(conversions.asObjectList(source, 'fields', function (doc) {
        return _this2._formFieldConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        fields: source.fields != null ? conversions.asObjectArray(source, 'fields', function (field) {
          return _this3._formFieldConverter.toDocument(field, conversions);
        }) : new Array()
      });
      return document;
    }
  }]);

  return FormDefinitionConverterImpl;
}(FormDefinitionConverter_1.FormDefinitionConverter);

FormDefinitionConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [FormFieldConverter_1.FormFieldConverter])], FormDefinitionConverterImpl);
exports.FormDefinitionConverterImpl = FormDefinitionConverterImpl;